import { __assign } from 'tslib';
import React__default from 'react';
import { ToastContainer as ToastContainer$1 } from 'react-toastify';
import { propTypes, defaultProps } from './ToastContainer.types.js';
import styles from './ToastContainer.module.scss.js';

var ToastContainer = function (props) { return (React__default.createElement(ToastContainer$1, __assign({ closeButton: false, closeOnClick: false, className: styles["ToastContainer___".concat(props.stylePosition)], enableMultiContainer: true }, props))); };
ToastContainer.displayName = 'ToastContainer';
ToastContainer.propTypes = propTypes;
ToastContainer.defaultProps = defaultProps;

export { ToastContainer, ToastContainer as default };
